import { createActions, handleActions } from 'redux-actions'

// helpers
import { startSubmitting } from './_helpers'

export const GENERATE_EMP501_FILE = 'emp501/GENERATE_EMP501_FILE'
export const GENERATE_EMP501_FILE_FAILURE = 'emp501/GENERATE_EMP501_FILE_FAILURE'
export const GENERATE_EMP501_FILE_SUCCESS = 'emp501/GENERATE_EMP501_FILE_SUCCESS'

export const {
  emp501: { generateEmp501File, generateEmp501FileSuccess, generateEmp501FileFailure }
} = createActions({
  [GENERATE_EMP501_FILE]: undefined,
  [GENERATE_EMP501_FILE_FAILURE]: undefined,
  [GENERATE_EMP501_FILE_SUCCESS]: undefined
})

const initialState = {
  errorMessage: null,
  hasError: false,
  isLoading: false,
  isSubmitting: false,
  isSuccess: null
}

export default handleActions(
  {
    [GENERATE_EMP501_FILE]: startSubmitting,
    [GENERATE_EMP501_FILE_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSuccess: false
    }),
    [GENERATE_EMP501_FILE_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      hasSubmitted: true,
      isSuccess: true,
      hasError: false
    })
  },
  initialState
)
